import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Page } from 'src/app/models/page.model';
import { CommonService } from 'src/app/services/common.service';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Subject, Subscription } from 'rxjs';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-documentlibrary',
  templateUrl: './documentlibrary.page.html',
  styleUrls: ['./documentlibrary.page.scss'],
})
export class DocumentlibraryPage implements OnInit {
  @ViewChild("focusAlert") focusAlert: ElementRef;
  @ViewChild('tableList') tableList: DatatableComponent;

  page = new Page();
  tableRows = [];
  preventClick: boolean = true;

  itemsSelected: any = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;

  searchText: string = '';
  searchListText: string = '';
  filterId: string = '';
  filterListId: string = '';
  sort: string = '';
  typeSort: string = '';
  typeListSort: string = '';
  sortList: string = '';
  newpage = new Page();
  showPage: boolean = false;
  rows = [];
  bookmarkList = [];
  completeDocumentList = [];
  incompleteDocumentList = [];
  standardDocument = [];
  ownDocument = [];
  sortingList: any = []
  columnsWidth: any = [];
  TemplateType: any = [];
  sectionList: any = [];
  displayTable: boolean = false;
  expandFavorite: boolean = true;
  expandCompleteDoc: boolean = true;
  expandIncompleteDoc: boolean = true;
  expandStandardDoc: boolean = true;
  expandOwnDoc: boolean = true;
  favoriteIcon: string = 'chevron-up-outline';
  completeDocIcon: string = 'chevron-up-outline';
  incompleteDocIcon: string = 'chevron-up-outline';
  standardDocIcon: string = 'chevron-up-outline';
  ownDocIcon: string = 'chevron-up-outline';
  libraryPages: any = {};
  showBookmarkShowMore: boolean;
  showCompleteShowMore: boolean;
  showIncompleteShowMore: boolean;
  showStandardShowMore: boolean;
  showOwnDocumentsShowMore: boolean;
  noBookmarkAvailable: boolean;
  nocompleteDocAvailable: boolean;
  noIncompleteAvailable: boolean;
  noStandardDocAvailable: boolean;
  noOwnDocumentsAvailable: boolean;
  listView: boolean = true;
  DocumentType: string = "";
  ListDocumentType: string = "";
  sortLabel: string = "";
  typeSortLabel: string = "";
  currentListPage = 0;
  sizeChange:boolean = false;

  remarks: string = '';
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adjustColumnWidth();
  }

  @Input() rating: number = 0;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter();

  adjustColumnWidth() {
      if (this.tableList && window.innerWidth > 900) {
        this.sizeChange = false;
        let tableWidth = this.tableList._innerWidth - 160;
        // this.columnsWidth.FavouriteIcon = (6 / 100) * tableWidth;
        // this.columnsWidth.FeedBackIcon = (6 / 100) * tableWidth;
        this.columnsWidth.DocumentName = (50 / 100) * tableWidth;
        this.columnsWidth.DocumentTemplateTypeName = (15 / 100) * tableWidth;
        this.columnsWidth.DateCreated = (15 / 100) * tableWidth;
        this.columnsWidth.DocumentType = (20 / 100) * tableWidth;
      }
      if (this.tableList && window.innerWidth < 900) {
        this.sizeChange = true;
        let tableWidth = this.tableList._innerWidth;
        // this.columnsWidth.FavouriteIcon = (10 / 100) * tableWidth;
        // this.columnsWidth.FeedBackIcon = (10 / 100) * tableWidth;
        this.columnsWidth.DocumentName = (100 / 100) * tableWidth;
        this.columnsWidth.DocumentTemplateTypeName = null;
        this.columnsWidth.DateCreated = null;
        this.columnsWidth.DocumentType = null;
      }
      if(this.tableList){
        this.tableList.recalculate();
      }

  }

  constructor(private router: Router, public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, private _apiService: ApiService, public _commonService: CommonService) {
    this.page.pageNumber = 1;
    this.newpage.pageNumber = 0;
    this.newpage.size = 50;
    this.searchEvent = this._commonService.searchTextValue;
    this.libraryPages.sizeBookmark = 0;
    this.libraryPages.sizeComplete = 0;
    this.libraryPages.sizeIncomplete = 0;
    this.libraryPages.sizeStandard = 0;
    this.libraryPages.sizeOwn = 0;
  }

  public onLimitChange(limit: any): void {
    this.newpage.size = parseInt(limit, 10);
    if (this.searchListText && this.searchListText != '') {
      this.setPage({ offset: 0 }, this.searchListText);
    } else {
      this.setPage({ offset: 0 }, '');
    }
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.filterId = '';
    this.filterListId = this.filterListId ? this.filterListId : '';
    this.sort = '';
    this.typeSort = '';
    this.typeSortLabel = '';
    this.searchText = '';
    this.searchListText = '';
    this.filterListId = '';
    this.sortList = '';
    this.typeListSort = '';
    if (localStorage.libraryTileFilters) {
      let cacheTileValue = JSON.parse(localStorage.libraryTileFilters);
      this.searchText = cacheTileValue.searchText ? cacheTileValue.searchText : '';
      this.filterId = cacheTileValue.filterId ? cacheTileValue.filterId : '';
      this.sortLabel = cacheTileValue.sortLabel ? cacheTileValue.sortLabel : '';
      this.sort = this.sortLabel;
      this.typeSort = cacheTileValue.typeSort ? cacheTileValue.typeSort : '';
      this.typeSortLabel = this.typeSort;
      this.libraryPages.sizeBookmark = cacheTileValue.sizeBookmark ? cacheTileValue.sizeBookmark : 0;
      this.libraryPages.sizeComplete = cacheTileValue.sizeComplete ? cacheTileValue.sizeComplete : 0;
      this.libraryPages.sizeIncomplete = cacheTileValue.sizeIncomplete ? cacheTileValue.sizeIncomplete : 0;
      this.libraryPages.sizeStandard = cacheTileValue.sizeStandard ? cacheTileValue.sizeStandard : 0;
      this.libraryPages.sizeOwn = cacheTileValue.sizeOwn ? cacheTileValue.sizeOwn : 0;
      this.page.pageNumber = cacheTileValue.pageNumber ? cacheTileValue.pageNumber : 1;
    }

    if (localStorage.libraryListFilters) {
      let cacheListValue = JSON.parse(localStorage.libraryListFilters);
      this.searchListText = cacheListValue.searchListText ? cacheListValue.searchListText : '';
      this.filterListId = cacheListValue.filterListId ? cacheListValue.filterListId : '';
      this.sortList = cacheListValue.sortList ? cacheListValue.sortList : '';
      this.typeListSort = cacheListValue.typeListSort ? cacheListValue.typeListSort : '';
      this.currentListPage = cacheListValue.currentListPage ? cacheListValue.currentListPage : 0;
      this.newpage.pageNumber = cacheListValue.pageNumber ? cacheListValue.pageNumber : 0;
      this.newpage.orderBy = cacheListValue.orderBy ? cacheListValue.orderBy : '';
      this.newpage.orderDir = cacheListValue.orderDir ? cacheListValue.orderDir : '';
      this.newpage.size = cacheListValue.size ? cacheListValue.size : 50;
    }
    this.showPage = false;
    // this.setPageBookmark({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    // this.setPageDownloadedBefore({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    // this.setPageIncomplete({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    // this.setPageStandardDocument({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    // this.setPageOwnDocuments({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    this.sortingList = [{
      Id: "TEMPASC", Name: this._commonService.getLocalTranslation('label-azTemplate'), Label: 'label-azTemplate'
    },
    { Id: "TEMPDESC", Name: this._commonService.getLocalTranslation('label-zaTemplate'), Label: 'label-zaTemplate' },
    { Id: "DOCASC", Name: this._commonService.getLocalTranslation('label-azDocument'), Label: 'label-azDocument' },
    { Id: "DOCDESC", Name: this._commonService.getLocalTranslation('label-zaDocument'), Label: 'label-zaDocument' },
    { Id: "DESCDOCUMENTCREATED", Name: this._commonService.getLocalTranslation('label-latestDocumentCreated'), Label: 'label-latestDocumentCreated' }];
    this.sectionList = [
      { Name: this._commonService.getLocalTranslation('label-ownDocument'), Label: 'own' },
      { Name: this._commonService.getLocalTranslation('label-favorite'), Label: 'favourite' },
      { Name: this._commonService.getLocalTranslation('label-incompleteDocument'), Label: 'incomplete' },
      { Name: this._commonService.getLocalTranslation('label-downloadedBefore'), Label: 'complete' },
      { Name: this._commonService.getLocalTranslation('label-standardDocument'), Label: 'standard' },
    ];
    this.sectionList = [...this.sectionList.sort(function (a, b) {
      let alc = a.Name.toLowerCase(), blc = b.Name.toLowerCase();
      return alc > blc ? 1 : alc < blc ? -1 : 0;
    })];

    this.getTemplateType();
    this.itemsSelected = [];
    this.adjustColumnWidth();
    if (localStorage.libraryView) {
      if (localStorage.libraryView == 'tile') {
        this.viewTile()
      } else {
        this.showPage = true;
        this.viewList();
      }
    } else {
      this.showPage = true;
      this.viewList();
    }

  }

  ionViewDidLeave() {
    this.libraryPages.sizeBookmark = 0;
    this.libraryPages.sizeComplete = 0;
    this.libraryPages.sizeIncomplete = 0;
    this.libraryPages.sizeStandard = 0;
    this.libraryPages.sizeOwn = 0;
    this.itemsSelected = [];
    if (this.tableList) {
      this.tableList.selected = [];
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewWillLeave() {
    this._commonService.searchText = ''
    this.searchText = "";
    this.searchListText = "";
  }

  /**
* Populate the table with new data based on the page number
* @param page The page to select
*/
  async setPage(pageInfo, searchText) {
    this.searchListText = searchText;
    this.filterListId = this.filterListId ? this.filterListId : '';
    this.sortList = this.sortList ? this.sortList : '';
    this.typeListSort = this.typeListSort ? this.typeListSort : '';
    this._commonService.presentLoading();
    await this.adjustColumnWidth();
    this.currentListPage = pageInfo.offset;
    this.newpage.pageNumber = pageInfo.offset;
    this.tableList.offset = this.newpage.pageNumber;
    this.putvaluesOnLocalStorageForList();
    this._apiService.getDocumentLibrary(searchText ? searchText : "", this.sortList, this.typeListSort, this.newpage.orderBy, this.newpage.orderDir, this.newpage.pageNumber + 1, this.newpage.size, 'isList', this.filterListId).then(data => {
      this.newpage.totalElements = data.headers.get('X-Page-TotalCount');
      this.tableList.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.tableRows = data.body;
      this.tableList.selected = [];
      if (!this.tableList.element.className.includes("border-header border-footer")) this.tableList.element.className += " border-header border-footer";
      this.displayTable = true;
      this._commonService.log(this.tableRows, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this.displayTable = true;
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  async setPageBookmark(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this.filterId = this.filterId ? this.filterId : '';
    this.sort = this.sort ? this.sort : '';
    this.typeSort = this.typeSort ? this.typeSort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    // this.page.pageNumber = this.page.pageNumber + 1;
    if (this.libraryPages.sizeBookmark == 0) {
      this.libraryPages.sizeBookmark = this.libraryPages.sizeBookmark + 4;
    }
    this._apiService.getDocumentLibrary(searchText ? searchText : "", this.sortLabel, '', this.page.orderBy, this.page.orderDir, this.page.pageNumber, this.libraryPages.sizeBookmark, 'isBookmark', this.filterId).then(async (data) => {
      this.libraryPages.totalBookmarkeCount = data.headers.get('X-Page-TotalCount');

      this.showBookmarkShowMore = false;
      this.noBookmarkAvailable = false;
      if (this.libraryPages.totalBookmarkeCount == 0) {
        this.noBookmarkAvailable = true;
      }
      if (this.libraryPages.totalBookmarkeCount > 4 && data.body.length != this.libraryPages.totalBookmarkeCount) {
        this.showBookmarkShowMore = true;
      }
      this.bookmarkList = data.body;
      this.bookmarkList.forEach(async (element) => {
        element.isFavorite = 'true'
        if (element.ModuleId == "73744c0d-9647-4a7a-baa9-3bec926f1bd0") {
          element.moduleName = "Module_Quickscan";
          element.DisplayName = element.QuickScanName;
          element.Description = element.QuickScanDescription;
        } else if (element.ModuleId == "8a267bfc-794c-45f6-9690-7551b7412fc8") {
          element.DocumentName = element.Name;
          element.moduleName = "StandardDocument";
          element.DisplayName = this._commonService.getLocalTranslation('label-standardDocument');
          element.DocumentId = element.StandardDocumentId
          element.Description = element.Remarks
        } else if (element.Module == "Module_CustomDocument") {
          element.moduleName = "Module_CustomDocument";
          element.DisplayName = this._commonService.getLocalTranslation('label-ownDocument');
          element.Description = element.Remarks;
        } else {
          element.DisplayName = element.DocumentTemplateTypeName ? element.DocumentTemplateTypeName : "";
          element.moduleName = "Module_DocumentGenerator"
          element.Description = element.Remarks
        }
      });
      this.showPage = true;
      this.putvaluesOnLocalStorage();
      setTimeout(() => {
        this.typeLabelCheck()
      }, 500);
      this._commonService.log(this.bookmarkList, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  async setPageIncomplete(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this.filterId = this.filterId ? this.filterId : '';
    this.sort = this.sort ? this.sort : '';
    this.typeSort = this.typeSort ? this.typeSort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    // this.page.pageNumber = this.page.pageNumber + 1;
    if (this.libraryPages.sizeIncomplete == 0) {
      this.libraryPages.sizeIncomplete = this.libraryPages.sizeIncomplete + 4;
    }
    this._apiService.getDocumentLibrary(searchText ? searchText : "", this.sortLabel, '', this.page.orderBy, this.page.orderDir, this.page.pageNumber, this.libraryPages.sizeIncomplete, 'isIncomplete', this.filterId).then(async (data) => {
      this.libraryPages.totalIncompleteCount = data.headers.get('X-Page-TotalCount');
      this.noIncompleteAvailable = false;
      this.showIncompleteShowMore = false;

      if (this.libraryPages.totalIncompleteCount == 0) {
        this.noIncompleteAvailable = true;
      }
      if (this.libraryPages.totalIncompleteCount > 4 && data.body.length != this.libraryPages.totalIncompleteCount) {
        this.showIncompleteShowMore = true;
      }
      this.incompleteDocumentList = data.body;
      this.incompleteDocumentList.forEach(async (element) => {
        element.isFavorite = 'false';
        element.moduleName = "Module_DocumentGenerator";
        element.DisplayName = element.DocumentTemplateTypeName ? element.DocumentTemplateTypeName : "";
        element.Description = element.Remarks
      });
      this.showPage = true;
      this._commonService.log(this.incompleteDocumentList, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }
  async setPageDownloadedBefore(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this.filterId = this.filterId ? this.filterId : '';
    this.sort = this.sort ? this.sort : '';
    this.typeSort = this.typeSort ? this.typeSort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    // this.page.pageNumber = this.page.pageNumber + 1;
    if (this.libraryPages.sizeComplete == 0) {
      this.libraryPages.sizeComplete = this.libraryPages.sizeComplete + 4;
    }
    this._apiService.getDocumentLibrary(searchText ? searchText : "", this.sortLabel, '', this.page.orderBy, this.page.orderDir, this.page.pageNumber, this.libraryPages.sizeComplete, 'isDownloaded', this.filterId).then(async (data) => {
      this.libraryPages.totalCompleteCount = data.headers.get('X-Page-TotalCount');
      this.nocompleteDocAvailable = false;
      this.showCompleteShowMore = false;
      this.completeDocumentList = data.body;
      if (this.libraryPages.totalCompleteCount == 0) {
        this.nocompleteDocAvailable = true;
      }
      if (this.libraryPages.totalCompleteCount > 4 && data.body.length != this.libraryPages.totalCompleteCount) {
        this.showCompleteShowMore = true;
      }
      this.completeDocumentList.forEach(async (element) => {
        element.isFavorite = 'false';
        if (element.ModuleId == "73744c0d-9647-4a7a-baa9-3bec926f1bd0") {
          element.moduleName = "Module_Quickscan";
          element.DisplayName = element.QuickScanName;
          element.Description = element.QuickScanDescription;
        } else {
          element.DisplayName = element.DocumentTemplateTypeName ? element.DocumentTemplateTypeName : "";
          element.moduleName = "Module_DocumentGenerator"
          element.Description = element.Remarks
        }
      });

      this.showPage = true;
      this._commonService.log(this.completeDocumentList, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  async setPageStandardDocument(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this.filterId = this.filterId ? this.filterId : '';
    this.sort = this.sort ? this.sort : '';
    this.typeSort = this.typeSort ? this.typeSort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    // this.page.pageNumber = this.page.pageNumber + 1;
    if (this.libraryPages.sizeStandard == 0) {
      this.libraryPages.sizeStandard = this.libraryPages.sizeStandard + 4;
    }
    this._apiService.getLibraryStandardDocuments(searchText ? searchText : "", this.sortLabel, '', this.page.pageNumber, this.libraryPages.sizeStandard, 0, this.filterId).then(async (data) => {
      this.libraryPages.totalStandardCount = data.headers.get('X-Page-TotalCount');
      this.noStandardDocAvailable = false;
      this.showStandardShowMore = false;
      if (this.libraryPages.totalStandardCount == 0) {
        this.noStandardDocAvailable = true;
      }
      if (this.libraryPages.totalStandardCount > 4 && data.body.length != this.libraryPages.totalStandardCount) {
        this.showStandardShowMore = true;
      }
      this.standardDocument = data.body;
      this.standardDocument.forEach(async (element) => {
        element.isFavorite = 'false';
        element.moduleName = "StandardDocument";
        element.DocumentId = element.StandardDocumentId;
        element.DisplayName = this._commonService.getLocalTranslation('label-standardDocument');
        element.DocumentName = element.Name;
        element.Description = element.Remarks
      });
      this._commonService.log(this.standardDocument, this._commonService.LOG);
      this._commonService.dismiss();
      this.showPage = true;
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  onActivate(event) {
    if (event.type == 'click' && event.cellIndex != 1 && event.cellIndex != 0) {
      if (this.preventClick) {
        if (event.row.Section == "standard") {
          this.router.navigate(['/documentlibrary/' + 'standarddocument/' + event.row.StandardDocumentId + "/" + localStorage.domainId]);
        } else {
          this.router.navigate(['/documentlibrary/' + 'documents/' + event.row.DocumentId + "/" + localStorage.domainId]);
        }
      }
    }
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.newpage.orderBy = sort.prop.toLowerCase();
    this.newpage.orderDir = sort.dir;
    this.setPage({ offset: this.newpage.pageNumber }, this.searchListText);
  }

  public noopComparator(): number {
    return 0;
  }


  async setPageOwnDocuments(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this.filterId = this.filterId ? this.filterId : '';
    this.sort = this.sort ? this.sort : '';
    this.typeSort = this.typeSort ? this.typeSort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    // this.page.pageNumber = this.page.pageNumber + 1;
    if (this.libraryPages.sizeOwn == 0) {
      this.libraryPages.sizeOwn = this.libraryPages.sizeOwn + 4;
    }
    this._apiService.getDocumentLibrary(searchText ? searchText : "", this.sortLabel, '', this.page.orderBy, this.page.orderDir, this.page.pageNumber, this.libraryPages.sizeOwn, 'isOwnDocument', this.filterId).then(async (data) => {
      this.libraryPages.totalOwnDocuments = data.headers.get('X-Page-TotalCount');
      this.noOwnDocumentsAvailable = false;
      this.showOwnDocumentsShowMore = false;
      this.ownDocument = data.body;
      if (this.libraryPages.totalOwnDocuments == 0) {
        this.noOwnDocumentsAvailable = true;
      }
      if (this.libraryPages.totalOwnDocuments > 4 && data.body.length != this.libraryPages.totalOwnDocuments) {
        this.showOwnDocumentsShowMore = true;
      }
      this.ownDocument.forEach(async (element) => {
        element.isFavorite = 'false';
        element.moduleName = "Module_CustomDocument";
        element.DisplayName = this._commonService.getLocalTranslation('label-ownDocument');
        element.Description = element.Remarks;
        element.IsComplete = null;
      });

      this.showPage = true;
      this._commonService.log(this.completeDocumentList, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  showDetail(item) {
    if (item.moduleName == "StandardDocument") {
      this.router.navigate(['/documentlibrary/' + 'standarddocument/' + item.StandardDocumentId + "/" + localStorage.domainId]);
    } else {
      this.router.navigate(['/documentlibrary/' + 'documents/' + item.DocumentId + "/" + localStorage.domainId]);
    }
  }

  onChangeType(event) {
    // this.libraryPages.sizeBookmark = 0;
    // this.libraryPages.sizeComplete = 0;
    // this.libraryPages.sizeIncomplete = 0;
    // this.libraryPages.sizeStandard = 0;
    // this.libraryPages.sizeOwn = 0;
    if (event) {
      this.typeSortLabel = event,
        this.putvaluesOnLocalStorage();
      if (event.includes('own')) {
        document.getElementById('ownDocument').style.display = '';
      } else {
        document.getElementById('ownDocument').style.display = 'none';
      }

      if (event.includes('favourite')) {
        document.getElementById('favourite').style.display = '';
      } else {
        document.getElementById('favourite').style.display = 'none';
      }

      if (event.includes('incomplete')) {
        document.getElementById('incomplete').style.display = '';
      } else {
        document.getElementById('incomplete').style.display = 'none';
      }

      if (event.includes('complete')) {
        document.getElementById('downloaded').style.display = '';
      } else {
        document.getElementById('downloaded').style.display = 'none';
      }

      if (event.includes('standard')) {
        document.getElementById('standard').style.display = '';
      } else {
        document.getElementById('standard').style.display = 'none';
      }

      if (event.length == 0) {
        document.getElementById('ownDocument').style.display = '';
        document.getElementById('favourite').style.display = '';
        document.getElementById('incomplete').style.display = '';
        document.getElementById('downloaded').style.display = '';
        document.getElementById('standard').style.display = '';
      }
      //   this.setPageBookmark({ offset: 0 }, this.searchText);
      // this.setPageIncomplete({ offset: 0 }, this.searchText);
      // this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
      // this.setPageStandardDocument({ offset: 0 }, this.searchText);
      // this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    }

    if (!event) {
      this.typeSortLabel = '',
        document.getElementById('ownDocument').style.display = '';
      document.getElementById('favourite').style.display = '';
      document.getElementById('incomplete').style.display = '';
      document.getElementById('downloaded').style.display = '';
      document.getElementById('standard').style.display = '';

    }
  }

  onChangeSorting(event) {
    this.libraryPages.sizeBookmark = 0;
    this.libraryPages.sizeComplete = 0;
    this.libraryPages.sizeIncomplete = 0;
    this.libraryPages.sizeStandard = 0;
    this.libraryPages.sizeOwn = 0;
    if (event) {
      this.sortLabel = event,
        this.putvaluesOnLocalStorage();
      this.setPageBookmark({ offset: 0 }, this.searchText);
      this.setPageIncomplete({ offset: 0 }, this.searchText);
      this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
      this.setPageStandardDocument({ offset: 0 }, this.searchText);
      this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    }

    if (!event) {
      this.sortLabel = '',
        this.putvaluesOnLocalStorage();
      this.setPageBookmark({ offset: 0 }, this.searchText);
      this.setPageIncomplete({ offset: 0 }, this.searchText);
      this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
      this.setPageStandardDocument({ offset: 0 }, this.searchText);
      this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    }

  }
  showMore(section) {
    if (section == "favorite") {
      this.libraryPages.sizeBookmark = this.libraryPages.sizeBookmark + 4;
      this.setPageBookmark({ offset: 0 }, this.searchText);
    } else if (section == "incomplete") {
      this.libraryPages.sizeIncomplete = this.libraryPages.sizeIncomplete + 4;
      this.setPageIncomplete({ offset: 0 }, this.searchText);
    } else if (section == "complete") {
      this.libraryPages.sizeComplete = this.libraryPages.sizeComplete + 4;
      this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
    } else if (section == "standard") {
      this.libraryPages.sizeStandard = this.libraryPages.sizeStandard + 4;
      this.setPageStandardDocument({ offset: 0 }, this.searchText);
    } else if (section == "own") {
      this.libraryPages.sizeOwn = this.libraryPages.sizeOwn + 4;
      this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    }
  }

  async getTemplateType() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateType();
      this.TemplateType = res.body;
      let data = [{
        'DocumentTemplateTypeId': '73744c0d-9647-4a7a-baa9-3bec926f1bd0',
        'Name': this._commonService.getLocalTranslation('label-quickScan')
      },
      {
        'DocumentTemplateTypeId': "8a267bfc-794c-45f6-9690-7551b7412fc8",
        'Name': this._commonService.getLocalTranslation('label-standardDocument')
      }]
      data.forEach(element => {
        this.TemplateType.push(element);
      });

      this._commonService.dismiss();

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  putvaluesOnLocalStorage() {
    let obj = {
      searchText: this.searchText ? this.searchText : '',
      filterId: this.filterId ? this.filterId : '',
      sortLabel: this.sortLabel ? this.sortLabel : '',
      typeSort: this.typeSortLabel ? this.typeSortLabel : '',
      sizeBookmark: this.libraryPages.sizeBookmark ? this.libraryPages.sizeBookmark : 0,
      sizeComplete: this.libraryPages.sizeComplete ? this.libraryPages.sizeComplete : 0,
      sizeIncomplete: this.libraryPages.sizeIncomplete ? this.libraryPages.sizeIncomplete : 0,
      sizeStandard: this.libraryPages.sizeStandard ? this.libraryPages.sizeStandard : 0,
      sizeOwn: this.libraryPages.sizeOwn ? this.libraryPages.sizeOwn : 0,
      pageNumber: this.page.pageNumber ? this.page.pageNumber : 1
    }
    localStorage.libraryTileFilters = JSON.stringify(obj);
  }

  search() {
    this.putvaluesOnLocalStorage()
    this.libraryPages.sizeBookmark = 0;
    this.libraryPages.sizeComplete = 0;
    this.libraryPages.sizeIncomplete = 0;
    this.libraryPages.sizeStandard = 0;
    this.libraryPages.sizeOwn = 0;
    this.setPageBookmark({ offset: 0 }, this.searchText);
    this.setPageIncomplete({ offset: 0 }, this.searchText);
    this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
    this.setPageStandardDocument({ offset: 0 }, this.searchText);
    this.setPageOwnDocuments({ offset: 0 }, this.searchText);
  }

  putvaluesOnLocalStorageForList() {
    let obj = {
      searchListText: this.searchListText ? this.searchListText : '',
      filterListId: this.filterListId ? this.filterListId : '',
      sortList: this.sortList ? this.sortList : '',
      typeSort: this.typeSortLabel ? this.typeSortLabel : '',
      typeListSort: this.typeListSort ? this.typeListSort : '',
      currentListPage: this.currentListPage ? this.currentListPage : 0,
      pageNumber: this.newpage.pageNumber ? this.newpage.pageNumber : 0,
      orderBy: this.newpage.orderBy ? this.newpage.orderBy : '',
      orderDir: this.newpage.orderDir ? this.newpage.orderDir : '',
      size: this.newpage.size ? this.newpage.size : 50
    }
    localStorage.libraryListFilters = JSON.stringify(obj);
  }

  searchList() {
    this.setPage({ offset: 0 }, this.searchListText);
  }


  onChangeFilter(event) {
    this.libraryPages.sizeBookmark = 0;
    this.libraryPages.sizeComplete = 0;
    this.libraryPages.sizeIncomplete = 0;
    this.libraryPages.sizeStandard = 0;
    this.libraryPages.sizeOwn = 0;
    if (event) {
      this.filterId = event;
      this.putvaluesOnLocalStorage();
      this.setPageBookmark({ offset: 0 }, this.searchText);
      this.setPageIncomplete({ offset: 0 }, this.searchText);
      this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
      this.setPageStandardDocument({ offset: 0 }, this.searchText);
      this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    } else {
      this.filterId = '';
      this.putvaluesOnLocalStorage();
      this.setPageBookmark({ offset: 0 }, this.searchText);
      this.setPageIncomplete({ offset: 0 }, this.searchText);
      this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
      this.setPageStandardDocument({ offset: 0 }, this.searchText);
      this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    }
  }

  toggleSection(sectionName) {
    if (sectionName == "favorite") {
      if (this.expandFavorite) {
        this.expandFavorite = false;
        this.favoriteIcon = 'chevron-down-outline';
      } else {
        this.expandFavorite = true;
        this.favoriteIcon = 'chevron-up-outline';
      }
    } else if (sectionName == "complete") {
      if (this.expandCompleteDoc) {
        this.expandCompleteDoc = false;
        this.completeDocIcon = 'chevron-down-outline';
      } else {
        this.expandCompleteDoc = true;
        this.completeDocIcon = 'chevron-up-outline';
      }
    } else if (sectionName == "incomplete") {
      if (this.expandIncompleteDoc) {
        this.expandIncompleteDoc = false;
        this.incompleteDocIcon = 'chevron-down-outline';
      } else {
        this.expandIncompleteDoc = true;
        this.incompleteDocIcon = 'chevron-up-outline';
      }
    } else if (sectionName == "standard") {
      if (this.expandStandardDoc) {
        this.expandStandardDoc = false;
        this.standardDocIcon = 'chevron-down-outline';
      } else {
        this.expandStandardDoc = true;
        this.standardDocIcon = 'chevron-up-outline';
      }
    } else if (sectionName == "own") {
      if (this.expandOwnDoc) {
        this.expandOwnDoc = false;
        this.ownDocIcon = 'chevron-down-outline';
      } else {
        this.expandOwnDoc = true;
        this.ownDocIcon = 'chevron-up-outline';
      }
    }

  }
  toggle(Id, status, sectionName, item) {
    let newSectionName = "";
    if (status == 'makeFovorite') {
      if (sectionName == "favorite") {
        if (item.moduleName == "StandardDocument") {
          newSectionName = "standard"
        }
        this.rows = this.bookmarkList;
      } else if (sectionName == "incomplete") {
        this.rows = this.incompleteDocumentList;
      } else if (sectionName == "complete") {
        this.rows = this.completeDocumentList;
      } else if (sectionName == "standard") {
        this.rows = this.standardDocument;
      } else if (sectionName == "own") {
        this.rows = this.ownDocument;
      }
      if (sectionName == "standard") {
        this.rows.forEach(async (element) => {
          if (element.StandardDocumentId == Id) {
            element.isFavorite = 'true'
          }
        });
        this.favouriteDocument(Id, true, sectionName, item);
      } else {
        this.rows.forEach(async (element) => {
          if (element.DocumentId == Id) {
            element.isFavorite = 'true'
          }
        });
        if (newSectionName != "") sectionName = newSectionName;
        this.favouriteDocument(Id, true, sectionName, item);
      }
    } else if (status == 'removeFavorite') {
      if (sectionName == "favorite") {
        if (item.moduleName == "StandardDocument") {
          newSectionName = "standard"
        }
        this.rows = this.bookmarkList;
      } else if (sectionName == "incomplete") {
        this.rows = this.incompleteDocumentList;
      } else if (sectionName == "complete") {
        this.rows = this.completeDocumentList;
      } else if (sectionName == "standard") {
        this.rows = this.standardDocument;
      } else if (sectionName == "own") {
        this.rows = this.ownDocument;
      }
      if (sectionName == "standard") {
        this.rows.forEach(async (element) => {
          if (element.StandardDocumentId == Id) {
            element.isFavorite = 'false';
          }
        });
        this.favouriteDocument(Id, false, sectionName, item);
      } else {
        this.rows.forEach(async (element) => {
          if (element.DocumentId == Id) {
            element.isFavorite = 'false';
          }
        });
        if (newSectionName != "") sectionName = newSectionName;
        this.favouriteDocument(Id, false, sectionName, item);
      }
    }
  }

  async favouriteDocument(id, check, sectionName, item) {
    try {
      let data = {
        "isFavorite": check == true ? "1" : "0"
      }
      this._apiService.postLibraryFovouriteDocument(data, id, sectionName);
      this.noStandardDocAvailable = false;
      this.noBookmarkAvailable = false;
      this.noIncompleteAvailable = false;
      this.nocompleteDocAvailable = false;
      this.noOwnDocumentsAvailable = false;
      if (check == true) {
        if (sectionName == "standard") {
          this.standardDocument = this.standardDocument.filter(x => x.isFavorite != 'true');
          if (this.standardDocument.length == 0 && this.libraryPages.totalStandardCount <= 4) {
            this.noStandardDocAvailable = true;
          }
        } else {
          if (item.IsComplete == true) {
            this.completeDocumentList = this.completeDocumentList.filter(x => x.isFavorite != 'true');
            if (this.completeDocumentList.length == 0 && this.libraryPages.totalCompleteCount <= 4) {
              this.nocompleteDocAvailable = true;
            }
          } else if (item.IsComplete == false) {
            this.incompleteDocumentList = this.incompleteDocumentList.filter(x => x.isFavorite != 'true');
            if (this.incompleteDocumentList.length == 0 && this.libraryPages.totalIncompleteCount <= 4) {
              this.noIncompleteAvailable = true;
            }
          } else {
            this.ownDocument = this.ownDocument.filter(x => x.isFavorite != 'true');
            if (this.ownDocument.length == 0 && this.libraryPages.totalOwnDocuments <= 4) {
              this.noOwnDocumentsAvailable = true;
            }
          }
        }

        this.bookmarkList.push(item);
        if (this.bookmarkList.length == 0) {
          this.noBookmarkAvailable = true;
        }
      } else if (sectionName == "favorite" && check == false) {
        this.bookmarkList = this.bookmarkList.filter(x => x.isFavorite == 'true');
        if (this.bookmarkList.length == 0 && this.libraryPages.totalBookmarkeCount <= 4) {
          this.noBookmarkAvailable = true;
        }
        if (item.IsComplete == false) {
          this.incompleteDocumentList.push(item);
          if (this.incompleteDocumentList.length == 0 && this.libraryPages.totalIncompleteCount <= 4) {
            this.noIncompleteAvailable = true;
          }
        } else if (item.IsComplete == true) {
          this.completeDocumentList.push(item);
          if (this.completeDocumentList.length == 0 && this.libraryPages.totalCompleteCount <= 4) {
            this.nocompleteDocAvailable = true;
          }
        } else {
          this.ownDocument.push(item);
          if (this.ownDocument.length == 0 && this.libraryPages.totalOwnDocuments <= 4) {
            this.noOwnDocumentsAvailable = true;
          }
        }
      } else if (sectionName == "standard" && check == false) {
        this.bookmarkList = this.bookmarkList.filter(x => x.isFavorite == 'true');
        if (this.bookmarkList.length == 0 && this.libraryPages.totalBookmarkeCount <= 4) {
          this.noBookmarkAvailable = true;
        }
        this.standardDocument.push(item);
        if (this.standardDocument.length == 0 && this.libraryPages.totalStandardCount <= 4) {
          this.noStandardDocAvailable = true;
        }
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  openListRatingModal(item) {
    if (item.Module == "Module_Quickscan") {
      this.ListDocumentType = "Module_Quickscan";
    } else if (item.Module == "Module_StandardDocument") {
      this.ListDocumentType = "Module_StandardDocument";
    } else if (item.Module == "Module_CustomDocument") {
      this.ListDocumentType = "Module_CustomDocument";
    } else {
      this.ListDocumentType = "Module_DocumentGenerator";
    }
    this.rating = 0;
    this.remarks = ''
    this.ngxSmartModalService.getModal('DocumentLibraryRatingModal').open()
    setTimeout(() => {
      this.focusAlert.nativeElement.focus();
      document.getElementById('alertFocus').classList.add("rating-alert-button");
    }, 100);
  }


  openRatingModal(item) {
    if (item.Module == "Module_Quickscan") {
      this.DocumentType = "Module_Quickscan";
    } else if (item.moduleName == "Module_DocumentGenerator") {
      this.DocumentType = "Module_DocumentGenerator"
    } else if (item.moduleName == "StandardDocument") {
      this.DocumentType = "StandardDocument"
    }
    this.rating = 0;
    this.remarks = ''
    this.ngxSmartModalService.getModal('DocumentLibraryRatingModal').open()
    setTimeout(() => {
      this.focusAlert.nativeElement.focus();
      document.getElementById('alertFocus').classList.add("rating-alert-button");
    }, 100);
  }
  rate(index: number) {
    this.rating = index;
    this.ratingChange.emit(this.rating);
  }

  getColor(index: number) {
    if (index) {
      if (this.isAboveRating(index)) {
        return "../assets/star_favorite.svg";
      } else {
        return "../assets/star_favorite_fill.svg";
      }
    } else {
      return "../assets/star_favorite.svg";
    }

  }

  isAboveRating(index: number): boolean {
    return index > this.rating;
  }
  async RateAndCloseModal() {
    this.ngxSmartModalService.getModal('DocumentLibraryRatingModal').close();
    try {
      this._commonService.presentLoading();
      let moduleId;
      if (!this.listView) {
        if (this.ListDocumentType == "Module_Quickscan") {
          moduleId = "73744c0d-9647-4a7a-baa9-3bec926f1bd0"
        } else if (this.ListDocumentType == "Module_DocumentGenerator") {
          moduleId = "e00d9083-335a-4b6d-8b6a-06015b81bf2a"
        } else if (this.ListDocumentType == "Module_StandardDocument") {
          moduleId = "8a267bfc-794c-45f6-9690-7551b7412fc8"
        }
      } else {
        if (this.DocumentType == "Module_Quickscan") {
          moduleId = "73744c0d-9647-4a7a-baa9-3bec926f1bd0"
        } else if (this.DocumentType == "Module_DocumentGenerator") {
          moduleId = "e00d9083-335a-4b6d-8b6a-06015b81bf2a"
        } else if (this.DocumentType == "StandardDocument") {
          moduleId = "8a267bfc-794c-45f6-9690-7551b7412fc8"
        }
      }
      let data = {
        "ModuleId": moduleId,
        "UserRating": this.rating ? this.rating : null,
        "UserRemark": this.remarks ? this.remarks : null,
        "ExternalRefId": null
      }
      let res = await this._apiService.postUserRatings(data);
      if (res.id) {

      }
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-feedbackGiven'));
      this._commonService.log(data, this._commonService.LOG);
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }
  async closeRatingModal() {
    this.ngxSmartModalService.getModal('DocumentLibraryRatingModal').close();
  }
  add() {
    this.router.navigate(['/documentlibrary/' + 'documents/' + 0 + "/" + localStorage.domainId]);
  }

  viewList() {
    this.listView = false;
    localStorage.libraryView = "list";
    this.displayTable = false;
    this._commonService.presentLoading();
    setTimeout(() => {
      if (this.searchEvent) {
        this.searchSubscription = this.searchEvent.subscribe(event => {
          this.setPage({ offset: 0 }, event);
          this.searchListText = event;
        });
      }
      this.setPage({ offset: this.currentListPage ? this.currentListPage : 0 }, this.searchListText && this.searchListText != '' ? this.searchListText : '');
      this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
        setTimeout(() => {
          this.tableRows = [...this.tableRows];
          if (this.tableList) this.tableList.recalculate();
          this.adjustColumnWidth();
        }, 0)
      });
      this.resizeSubscription = this._commonService.onResize.subscribe(event => {
        this.adjustColumnWidth();
      });
    }, 1000);
  }

  viewTile() {
    this.listView = true;
    localStorage.libraryView = "tile";
    this.setPageBookmark({ offset: 0 }, this.searchText);
    this.setPageIncomplete({ offset: 0 }, this.searchText);
    this.setPageDownloadedBefore({ offset: 0 }, this.searchText);
    this.setPageStandardDocument({ offset: 0 }, this.searchText);
    this.setPageOwnDocuments({ offset: 0 }, this.searchText);
    setTimeout(() => {
      this.typeLabelCheck();
    }, 500);
  }

  typeLabelCheck() {
    if (this.listView) {
      if (Array.isArray(this.typeSortLabel)) {
        if (this.typeSortLabel.includes('own')) {
          document.getElementById('ownDocument').style.display = '';
        } else {
          document.getElementById('ownDocument').style.display = 'none';
        }

        if (this.typeSortLabel.includes('favourite')) {
          document.getElementById('favourite').style.display = '';
        } else {
          document.getElementById('favourite').style.display = 'none';
        }

        if (this.typeSortLabel.includes('incomplete')) {
          document.getElementById('incomplete').style.display = '';
        } else {
          document.getElementById('incomplete').style.display = 'none';
        }

        if (this.typeSortLabel.includes('complete')) {
          document.getElementById('downloaded').style.display = '';
        } else {
          document.getElementById('downloaded').style.display = 'none';
        }

        if (this.typeSortLabel.includes('standard')) {
          document.getElementById('standard').style.display = '';
        } else {
          document.getElementById('standard').style.display = 'none';
        }

        if (this.typeSortLabel.length == 0) {
          document.getElementById('ownDocument').style.display = '';
          document.getElementById('favourite').style.display = '';
          document.getElementById('incomplete').style.display = '';
          document.getElementById('downloaded').style.display = '';
          document.getElementById('standard').style.display = '';
        }
      } else {
        if(document.getElementById('ownDocument')){
          document.getElementById('ownDocument').style.display = '';
          document.getElementById('favourite').style.display = '';
          document.getElementById('incomplete').style.display = '';
          document.getElementById('downloaded').style.display = '';
          document.getElementById('standard').style.display = '';
        }
      }
    }
  }

  async makeFavourite(id, value,label,item) {
    try {
      let data = {
        "isFavorite": value == true ? "1" : "0"
      }
      this._commonService.presentLoading();
      if(id==null){
        label = 'standard';
        id = item.StandardDocumentId
      }
      if(label == 'standard'){
        await this._apiService.postLibraryFovouriteDocument(data, id, 'standard');
      }else{
        await this._apiService.postLibraryFovouriteDocument(data, id, '');
      }
      this.setPage({ offset: 0 }, this.searchListText);
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }



}
